import React from 'react'
import { convertirNumeroConComas } from '../../../../utils/numbers.utils'

const SEDatosProductoSuma = (props: any) => {
  return (
    <table className='w-100'>
      <tbody>
        <tr>
          <td className='label-column-fact align-end'>
            <div className='div-calculo-p-gray' style={{marginRight: '3%'}}>
              Subtotal
            </div>
          </td>
          <td className='total-column-fact align-end'>
            <div className='div-calculo-p-gray'>${props?.subtotal ? convertirNumeroConComas(props?.subtotal) : '0.00'}</div>
              
          </td>
        </tr>
        <tr>
          <td className='label-column-fact align-end'>
            <div className='div-calculo-p-gray' style={{marginRight: '3%'}}>
              Descuento
            </div>
          </td>
          <td className='total-column-fact align-end'>
            <div className='div-calculo-p-red'>${props?.descuento ? convertirNumeroConComas(props?.descuento) : '0.00'}</div>
          </td>
        </tr>
        <tr>
          <td className='label-column-fact align-end'>
            <div className='div-calculo-p-black' style={{marginRight: '3%'}}>
              Total
            </div>
          </td>
          <td className='total-column-fact align-end'>
            <div className='div-calculo-p-secondary'>${props.total ? convertirNumeroConComas(props?.total) : '0.00'}</div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default SEDatosProductoSuma
